export default __webpack_public_path__ + "static/squid-c206f2cc8cbf9e0b490d1cf6287894e4.png";